export const messagesOverview = {
    pt: {
        message:{
            abandonment: "Abandonos",
            accessesLast30Days: "Acessos nos últimos 30 dias",
            activeCampaigns: "Campanhas Ativas",
            activeSpots: "Locais ativos",
            blocked: "BLOQUEADO",
            cleanCache: "Limpar cache",
            cleared: "LIBERADO",
            connectedUsers: "Clientes conectados",
            engagement: "Engajamento",
            insertsLast30Days: "Inserções nos últimos 30 dias",
            ipFirewall: "IP Firewall",
            ipsFirewall: "IP's Firewall",
            lastComments: "Últimos comentários",
            linkedSpots: "Locais vinculados",
            observations: "Observações",
            registerIp: "Cadastrar IP",
            registeredUsers: "Usuários Cadastrados",
            temporarilyInactive: "(Temporariamente inativo)",
            updateAllBoxes: "Atualizar todos box",
            updateLoginTypes: "Atualizar tipos de login",
            viewAllComments: "Ver todos os comentários"
        }
    },
    es: {
        message:{
            abandonment:"Abandonados",
            accessesLast30Days:"Accesos en los últimos 30 días",
            activeCampaigns:"Campañas activas",
            activeSpots:"Lugares activos",
            blocked:"BLOQUEADO",
            cleanCache:"Limpiar cache",
            cleared:"PUBLICADO",
            connectedUsers:"Clientes conectados",
            engagement:"Compromiso",
            insertsLast30Days:"Inserciones en los últimos 30 días",
            ipFirewall:"Firewall IP",
            ipsFirewall:"Firewall de IP",
            lastComments:"Últimos comentarios",
            linkedSpots:"Lugares cerrados",
            observations:"Comentarios",
            registerIp:"Registre IP",
            registeredUsers:"Usuarios Registrados",
            temporarilyInactive:"(Temporalmente inactivo)",
            updateAllBoxes:"Actualizar todo el cuadro",
            updateLoginTypes:"Actualizar tipos de inicio de sesión",
            viewAllComments:"Ver todos los comentarios"
        }
    },
    en: {
        message:{
            abandonment: "Abandonment",
            accessesLast30Days: "Accesses in the last 30 days",
            activeCampaigns: "Active Campaigns",
            activeSpots: "Active Spots",
            blocked: "BLOCKED",
            cleanCache: "Clean cache",
            cleared: "CLEARED",
            connectedUsers: "Connected clients",
            engagement: "Engagement",
            insertsLast30Days: "Inserts in the last 30 days",
            ipFirewall: "IP Firewall",
            ipsFirewall: "IP's Firewall",
            lastComments: "Last comments",
            linkedSpots: "Linked Spots",
            observations: "Observations",
            registerIp: "Cadastrar IP",
            registeredUsers: "Registered Users",
            temporarilyInactive: "(Temporarily inactive)",
            updateAllBoxes: "Update all boxes",
            updateLoginTypes: "Update login types",
            viewAllComments: "View all comments"

        }
    }
}
